import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DefaultDatesState {
  defaultDates: any;
}

const initialState: DefaultDatesState = {
  defaultDates: null,
};

const DefaultDatesSlice = createSlice({
  name: "DefaultDates",
  initialState,
  reducers: {
    setDefaultDates: (state: DefaultDatesState, action: PayloadAction<{}>) => {
      state.defaultDates = action.payload;
    },
    updateDefaultDates: (
      state: DefaultDatesState,
      action: PayloadAction<{ activeTab: string; dates: any }>
    ) => {
      state.defaultDates[action.payload.activeTab].defaultRangeDate =
        action.payload.dates;
    },
    updateDefaultTrendDates: (
      state: DefaultDatesState,
      action: PayloadAction<{ activeTab: string; dates: any }>
    ) => {
      state.defaultDates[action.payload.activeTab].defaultTrendDates =
        action.payload.dates;
    },
    updateDateRangeOptions: (
      state: DefaultDatesState,
      action: PayloadAction<{ activeTab: string; dates: any }>
    ) => {
      state.defaultDates[action.payload.activeTab].dateRangeDateOptions =
        action.payload.dates;
    },
    updateShowDateRnage: (
      state: DefaultDatesState,
      action: PayloadAction<{ activeTab: string; state: any }>
    ) => {
      state.defaultDates[action.payload.activeTab].showDateRange =
        action.payload.state;
    },
    updateHideDateFilter: (
      state: DefaultDatesState,
      action: PayloadAction<{ activeTab: string; state: boolean }>
    ) => {
      if (state.defaultDates[action.payload.activeTab]) {
        state.defaultDates[action.payload.activeTab].hideDateFilter = action.payload.state;
      }
    },
    updateTrendDateOptions: (
      state: DefaultDatesState,
      action: PayloadAction<{ activeTab: string; dates: any }>
    ) => {
      state.defaultDates[action.payload.activeTab].trendDateOptions =
        action.payload.dates;
    },
  },
});

export const {
  setDefaultDates,
  updateDefaultDates,
  updateDefaultTrendDates,
  updateTrendDateOptions,
  updateDateRangeOptions,
  updateShowDateRnage,
  updateHideDateFilter,
} = DefaultDatesSlice.actions;
export default DefaultDatesSlice.reducer;
